module.exports = __webpack_public_path__ + "static/img/70.b7f69e6d.gif";